import { render, staticRenderFns } from "./TaskDashboard.vue?vue&type=template&id=77bc2ce6&"
import script from "./TaskDashboard.vue?vue&type=script&lang=js&"
export * from "./TaskDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports